/*
 * Copyright (c) Nexign, JSC, 2022.
 */
/**
 *
 *
 * @author Yakov Gushchin
 * @version 1.20.1
 * @since 1.19.0
 */

import { getCampaignsInternalPrefilterUrl } from '@/main/pages/PageCampaign/utils/getCampaignsPageUrl';

import { ECampaignsType } from '../../../../../pages/PageCampaign';
import { ITableLinkProps } from './types';

export const useTableCellCampaign = (id: string, value: number, type: ECampaignsType): ITableLinkProps => {

    return {
        url: getCampaignsInternalPrefilterUrl( type, id),
        children: value,

        noValue: !id || !value,
    };
};
